var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingNewLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x9A\x99\xEF\xB8\x8F Icon / Variants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.889 38.0275C57.889 36.3246 59.2695 34.9441 60.9723 34.9441H71.2501C72.953 34.9441 74.3334 36.3246 74.3334 38.0275C74.3334 39.7303 72.953 41.1108 71.2501 41.1108H60.9723C59.2695 41.1108 57.889 39.7303 57.889 38.0275Z",
    fill: "#4589ff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3334 38.0275C37.3334 36.3246 38.7139 34.9441 40.4168 34.9441H50.6946C52.3974 34.9441 53.7779 36.3246 53.7779 38.0275C53.7779 39.7303 52.3974 41.1108 50.6946 41.1108H40.4168C38.7139 41.1108 37.3334 39.7303 37.3334 38.0275Z",
    fill: "#4589ff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.889 48.3052C57.889 46.6023 59.2695 45.2219 60.9723 45.2219H71.2501C72.953 45.2219 74.3334 46.6023 74.3334 48.3052C74.3334 50.0081 72.953 51.3886 71.2501 51.3886H60.9723C59.2695 51.3886 57.889 50.0081 57.889 48.3052Z",
    fill: "#4589ff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3334 48.3052C37.3334 46.6023 38.7139 45.2219 40.4168 45.2219H50.6946C52.3974 45.2219 53.7779 46.6023 53.7779 48.3052C53.7779 50.0081 52.3974 51.3886 50.6946 51.3886H40.4168C38.7139 51.3886 37.3334 50.0081 37.3334 48.3052Z",
    fill: "#4589ff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.889 28.5687C57.889 26.8658 59.2695 25.4853 60.9723 25.4853H71.2501C72.953 25.4853 74.3334 26.8658 74.3334 28.5687C74.3334 30.2716 72.953 31.652 71.2501 31.652H60.9723C59.2695 31.652 57.889 30.2716 57.889 28.5687Z",
    fill: "#4589ff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4723 10.5026C79.4723 9.7547 78.699 9.25724 78.0184 9.56732L32.7962 30.1715C32.4297 30.3385 32.1946 30.7041 32.1946 31.1068V55.4997H26.0279V31.1068C26.0279 28.2879 27.6742 25.7286 30.2394 24.5599L75.4616 3.95567C80.2257 1.78508 85.639 5.26739 85.639 10.5026V88.3886H79.4723V10.5026Z",
    fill: "#4589ff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8612 58.5853C19.8612 57.9387 20.4513 57.4527 21.086 57.5766L66.3082 66.407C66.7908 66.5012 67.139 66.924 67.139 67.4157V88.3886H73.3057V67.4157C73.3057 63.9739 70.868 61.0142 67.49 60.3546L22.2678 51.5243C17.825 50.6567 13.6946 54.0587 13.6946 58.5853V88.3886H19.8612V58.5853Z",
    fill: "#4589ff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55566 91.4719C8.55566 89.769 9.93612 88.3886 11.639 88.3886H87.6946C89.3974 88.3886 90.7779 89.769 90.7779 91.4719C90.7779 93.1748 89.3974 94.5552 87.6946 94.5552H11.639C9.93612 94.5552 8.55566 93.1748 8.55566 91.4719Z",
    fill: "#4589ff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2501 78.1108C34.2501 74.1374 37.4712 70.9163 41.4446 70.9163H45.5557C49.529 70.9163 52.7501 74.1374 52.7501 78.1108V88.3886H46.5834V78.1108C46.5834 77.5432 46.1233 77.083 45.5557 77.083H41.4446C40.8769 77.083 40.4168 77.5432 40.4168 78.1108V88.3886H34.2501V78.1108Z",
    fill: "#4589ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingNewLarge);
export default __webpack_public_path__ + "static/media/BuildingNewLarge.09584b9891428a3a417f4f7babb6d033.svg";
export { ForwardRef as ReactComponent };